import React, { useState, } from 'react';
import { Modal, Form, Row, Col, Input, message } from 'antd';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { BasicFormWrapper } from '../../../container/styled';
import { Button } from '../../buttons/buttons';
import { getAxiosInstance } from '../../../Api/ApiConfig';

function AuthInfo({ userId, setOpen, open, mustHave, setMustHave }) {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [oldPass, setOldPass] = useState();
    const [newPass, setNewPass] = useState();
    const localData = useSelector((state) => state.localRedux);
    const Role = localData?.MultiverseRole

    const onSubmit = async () => {
        const formData = {
            oldPassword: oldPass,
            newPassword: newPass,
        };
        try {
            if (['Multivrse Admin', 'Standard User', 'Proof Reader', 'Translator'].includes(Role)) {
                const response = await getAxiosInstance().put(`/usermgmt/resetPasswordForUserProfile/${userId}`, formData);
                if (response.data.statusCode === 200) {
                    setOpen(false);
                    setLoading(false);
                    setMustHave()
                    message.success('Password updated successfully');
                } else {
                    message.error('Failed to update password. Please try again.');
                }
            } else {
                const response = await getAxiosInstance().put(
                    `/usermgmt/resetPasswordForCustomerProfile/${userId}`,
                    formData);
                if (response.data.statusCode === 200) {
                    setOpen(false);
                    setLoading(false);
                    setMustHave()
                    message.success('Password updated successfully');
                } else {
                    message.error('Failed to update password. Please try again.');
                }
            }
        } catch (error) {
            if (error.response && error.response.data && error.response.data.message) {
                message.error(error.response.data.message);
            } else {
                message.error('An error occurred while updating the password.');
            }
        }
    };

    const handleOk = () => {
        onSubmit();
        setLoading(true);
    };
    const handleCancel = () => {
        setOpen(false);
    };
    return (
        <Modal
            open={open}
            title="Change Password"
            onOk={handleOk}
            onCancel={handleCancel}
            closable={mustHave !== "MustHave"}
            footer={[
                <>
                    {mustHave !== "MustHave" ?
                        <Button key="back" className="btn-danger" onClick={handleCancel}>
                            <FeatherIcon icon="x" className="text_iconspace" />
                            cancel
                        </Button> : ""}
                    <Button key="submit" className="btn-success" loading={loading} onClick={() => form.submit()}>
                        <FeatherIcon icon="save" className="text_iconspace" />
                        Submit
                    </Button>
                </>
            ]}
        >
            <div className="user-info-form">
                <BasicFormWrapper>
                    <Form style={{ width: '100%' }} form={form} name="info" onFinish={(values) => onSubmit(values)} colon={false}>
                        <Row>
                            <Col span={24} style={{ marginBottom: 15 }}>
                                <Form.Item name="old" rules={[{ required: true, message: 'Please enter old password' }]} label="Enter Old Password">
                                    <Input.Password placeholder="Enter Old Password" type="password" value={oldPass} onChange={(e) => setOldPass(e.target.value)} />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item name="new" rules={[
                                    {
                                        required: true,
                                        message: 'Please enter new password'
                                    },
                                    {
                                        pattern: /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                                        message: 'Password must be at least 8 characters long, contain an uppercase letter, a number, and a special character.',
                                    }
                                ]} label="Enter New Password">
                                    <Input.Password placeholder="Enter New Password" type="password" value={newPass} onChange={(e) => setNewPass(e.target.value)} />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </BasicFormWrapper>
            </div>
        </Modal>
    );
}
AuthInfo.propTypes = {
    open: PropTypes.bool.isRequired,
    userId: PropTypes.number.isRequired,
    setOpen: PropTypes.func.isRequired,
    mustHave: PropTypes.string.isRequired,
    setMustHave: PropTypes.func.isRequired,
};
export default AuthInfo;